import React from 'react';
import { Grid, Typography } from '@mui/material';

import CloseButton from './shared/CloseButton';
import EntityInfo from './shared/EntityInfo';

import { GridMainContainer, sxStyle } from '../styles';

const Flights = ({
  searchType,
  bookingDetails,
  useBookingColor,
  hasEntity,
  getHref,
  formatDate,
  history,
}) => {
  return (
    <GridMainContainer
      searchType={searchType}
      data-testid="bookingDetail_view_flights"
    >
      <Grid container direction="column" alignItems="center" sx={sxStyle.root}>
        <Grid item sx={sxStyle.gridPadding}>
          <Grid item container direction="column" alignItems="center">
            <Typography align="center" sx={sxStyle.bookingDetailTitle}>
              ¡Encontramos la reserva!
            </Typography>
            <Typography sx={sxStyle.bookingDetailSubtitle}>
              Código PNR: {bookingDetails?.PNR_code}
            </Typography>

            <Grid container sx={sxStyle.gridContainer}>
              <Grid
                item
                sx={{
                  ...sxStyle.status,
                  backgroundColor: useBookingColor(
                    bookingDetails?.pnr_status?.description
                  ),
                }}
              >
                Estado: {bookingDetails?.pnr_status?.description}
              </Grid>

              <Grid item container sx={sxStyle.gridBookingDetail}>
                <Grid
                  item
                  xs={12}
                  sx={
                    hasEntity
                      ? sxStyle.gridItemBookingDetailHotel
                      : sxStyle.gridItemBookingDetailOnlyHotel
                  }
                >
                  <Typography sx={sxStyle.bookingDetailText}>
                    <Typography component="span" sx={{ fontWeight: 600 }}>
                      Vuelos
                    </Typography>
                  </Typography>

                  <Typography sx={sxStyle.bookingDetailText}>
                    Aerolinea: {bookingDetails?.itinerary?.validating_carrier}
                  </Typography>

                  {bookingDetails?.itinerary.flights[0].title == 'Tramo 1' ? (
                    bookingDetails?.itinerary.flights.map((element, index) => (
                      <Grid key={+index}>
                        <Typography sx={sxStyle.bookingDetailText}>
                          {element.title}
                        </Typography>
                        <Typography sx={sxStyle.bookingDetailText}>
                          Origen: {element.flight[0].origin_description}
                        </Typography>
                        <Typography sx={sxStyle.bookingDetailText}>
                          Destino:{' '}
                          {
                            element.flight[element.flight.length - 1]
                              .destination_description
                          }
                        </Typography>
                        <Typography sx={sxStyle.bookingDetailText}>
                          Fecha de salida: {formatDate(element.departure)}
                        </Typography>
                      </Grid>
                    ))
                  ) : (
                    <>
                      <Typography sx={sxStyle.bookingDetailText}>
                        Origen:{' '}
                        {
                          bookingDetails?.itinerary.flights[0].flight[0]
                            .origin_description
                        }
                      </Typography>
                      <Typography sx={sxStyle.bookingDetailText}>
                        Destino:{' '}
                        {
                          bookingDetails?.itinerary.flights[0].flight[
                            bookingDetails?.itinerary.flights[0].flight.length -
                              1
                          ].destination_description
                        }
                      </Typography>
                      <Typography sx={sxStyle.bookingDetailText}>
                        Fecha de salida:{' '}
                        {formatDate(
                          bookingDetails?.itinerary.flights[0].departure
                        )}
                      </Typography>
                      {bookingDetails.itinerary.flights.length == 2 &&
                        bookingDetails.itinerary.flights[1].title ==
                          'VUELTA' && (
                          <Typography sx={sxStyle.bookingDetailText}>
                            Fecha de regreso:{' '}
                            {formatDate(
                              bookingDetails?.itinerary.flights[1].departure
                            )}
                          </Typography>
                        )}
                    </>
                  )}
                </Grid>
                <EntityInfo
                  bookingDetails={bookingDetails}
                  getHref={getHref}
                  sxStyle={sxStyle}
                  hasEntity={hasEntity}
                />
              </Grid>
            </Grid>
            <CloseButton history={history} />
          </Grid>
        </Grid>
      </Grid>
    </GridMainContainer>
  );
};

export default Flights;
